import * as React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Helmet from "react-helmet";
//
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { PageIntro } from "../components/PageIntro";
import { BottomBanner } from "../components/BottomBanner";
import { LayoutContainer } from "../components/LayoutContainer";
import { EventCard } from "../components/EventCard";
//

const Events = () => {
  const rawData = useStaticQuery(graphql`
    query {
      allSanityEvents {
        nodes {
          title
          subtitle
          postedAt(formatString: "D MMM YYYY")
          type
          slug {
            current
          }
          coverUrl
          cover {
            asset {
              gatsbyImageData(fit: FILL, placeholder: NONE)
            }
          }
        }
      }
    }
  `);

  const data: any[] = rawData.allSanityEvents.nodes;

  return (
    <>
      <Header hasPageIntro={true} />
      <PageIntro title="Events & Contests" subTitle="" />
      <LayoutContainer className="sm:py-24">
        <div className="sm:grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12 sm:mb-16 flex flex-col">
          {data.map((item, index) => {
            return (
              <EventCard
                key={index}
                thumbnail={item.cover.asset}
                title={item.title}
                subtitle={item.subtitle}
                link={item.slug.current}
                type={item.type}
                className="flex-shrink-0 w-[300px] sm:w-auto"
              />
            );
          })}
        </div>
      </LayoutContainer>
      <BottomBanner />
      <Footer />
    </>
  );
};

export default Events;
